export enum ENatsActions {
  STATUS_CHANGE = 'order-status-changed',
  ORDER_UPDATED = 'order-updated',
  PAYMENTS_ADDED = 'payments-added',
  PAYMENT_AUTH_ADDED = 'payment-auth-added',
}
